<template>
  <div class="Coding">
    <b-loading :is-full-page="true" :active.sync="isLoading" :can-cancel="false"></b-loading>
    <div class="Navbar">
      <section class="hero is-white is-fullwidth" style="text-align:start">
        <div class="hero-body" style="border-bottom: medium solid #4a4a4a;">
          <div class="container">
            <h1 class="title">プログラミング</h1>
            <h2 class="subtitle">じゃんけんのプログラムを作ってみよう！</h2>
          </div>
        </div>
      </section>
    </div>

    <section class="hero is-white">
      <h1>タイトル</h1>
      <div v-if="isTitleError">
        <input class="input is-danger" type="text" placeholder="名前" v-model="title" />
      </div>
      <div v-else>
        <input class="input is-info" type="text" placeholder="名前" v-model="title" />
      </div>

      <h1>プログラム</h1>
      <codemirror v-model="code" :options="cmOptions" style="text-align:start;"></codemirror>
      <br />
      <a class="button is-primary is-large is-fullwidth" @click="postData">送信</a>
      <p v-text="postLog">デバッグ</p>
      <p v-text="errorLog" style="	color:red">デバッグ</p>
    </section>
  </div>
</template>

<script>
const apiUrl =
  process.env.VUE_APP_DB_API;
const config = {
  headers: {
    "Content-Type": "application/json"
  }
};
import { mapState } from "vuex";
import { mapMutations } from "vuex";
import axios from "axios";
import { log } from "util";
import { constants } from "crypto";

import { codemirror } from "vue-codemirror";
import "codemirror/lib/codemirror.css";
import "codemirror/mode/python/python.js";
import "codemirror/theme/mbo.css";
import "codemirror/addon/selection/active-line.js";
// closebrackets
import "codemirror/addon/edit/closebrackets.js";

export default {
  data() {
    return {
      postLog: "",
      errorLog: "",
      isTitleError: false,
      isLoading: false,
      cmOptions: {
        autoCloseBrackets: true,
        tabSize: 4,
        lineNumbers: true,
        line: true,
        mode: "text/x-python",
        theme: "mbo"
      }
    };
  },
  components: {
    codemirror
  },
  computed: {
    title: {
      get() {
        return this.$store.state.user_title;
      },
      set(n) {
        this.$store.commit("setUserTitle", n);
      }
    },
    code: {
      get() {
        return this.$store.state.user_code;
      },
      set(c) {
        this.$store.commit("setUserCode", c);
      }
    },
    codemirror() {
      return this.$refs.myCm.codemirror;
    },
    user() {
      return this.$store.getters.user;
    },
    userStatus() {
      return this.$store.getters.isSignedIn;
    }
  },

  methods: {
    postData() {
      if (this.title == "") {
        this.isTitleError = true;
        this.$buefy.dialog.alert({
          title: "Error",
          message: "タイトルを入力してください",
          type: "is-danger",
          hasIcon: true,
          icon: "times-circle",
          iconPack: "fa",
          ariaRole: "alertdialog",
          ariaModal: true
        });
        return;
      }

      if (this.userStatus == false) {
        this.$buefy.dialog.alert({
          title: "Info",
          message: "プログラムの投稿には<br>ログインが必要です",
          type: "is-info",
          hasIcon: true,
          icon: "info-circle",
          iconPack: "fa",
          ariaRole: "alertdialog",
          ariaModal: true
        });
        return;
      } else {
        this.isTitleError = false;
      }

      this.isLoading = true;

      this.postLog = "データを送信しています";

      console.log(this.user.uid)

      this.$axios
        .post(apiUrl, {
          title: this.title,
          code: this.code,
          idpid: this.user.uid,
          uname: this.user.providerData[0].displayName
        })
        .then(response => {
          console.table(response.data);
          if (response.data.errorMessage) {
            this.postLog = "データの送信に失敗しました";
            this.errorLog = response.data.errorMessage;
          } else {
            this.$buefy.dialog.alert({
              title: "Success!",
              message: "プログラムを送信しました。<br>ランキングを確認してみよう！",
              type: "is-primary",
              hasIcon: true,
              icon: "check-circle",
              iconPack: "fa",
              ariaRole: "alertdialog",
              ariaModal: true
            });

            this.postLog = "データを送信しました";
            this.$store.commit("setBattle_p", response.data.id);
            this.errorLog = "";
          }
        })
        .catch(reason => {
          this.ip = "データの送信に失敗しました";
          this.errorLog = reason.data.errorMessage;
        })
        .finally(reason => {
          this.isLoading = false;
        });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1 {
  margin-top: 20px;
  font-size: 30px;
  text-align: left;
}
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>